<template>
  <div class="bg" v-show="show">
    <div class="content pa bg_fff" @click.stop>

      <div class="city-header">
        <h3 class="city-title">请选择城市</h3>
        <i class="iconfont iconquxiao" @click="closeFunc()"></i>
      </div>
      <div class="position-box">
        <span :class="(positionIndex === nowIndex) && 'active'" 
          v-for="(positionItem, positionIndex) in positionMap" 
          :key="positionIndex + 'positionItem'"
          @click="toggleTag(positionItem, positionIndex)"
        >
          {{ positionItem }}
        </span>
      </div>

      <div ref="city-content" class="city-content">
        <!-- 热门城市 -->
        <div class="city-item">
          <span class="city-tag" style="opacity: 0;">A</span>
          <div class="city-box">
            <span class="city" :class="{'active': activeCity === hotItem.city_name }" v-for="(hotItem, hotIndex) in hot_cities" :key="hotIndex + 'hotCity'" @click="clickFunc(hotItem)">{{ hotItem.city_name }}</span>
          </div>
        </div>

        <!-- A-Z城市 -->
        <div :ref="`tag-${cityItem.group_name}`" class="city-item" v-for="(cityItem, cityIndex) in cities" :key="cityIndex + 'cityItem'">
          <span class="city-tag">{{ cityItem.group_name }}</span>
          <div class="city-box">
            <span class="city" :class="{'active': activeCity === item.city_name }" v-for="(item, index) in cityItem.part_cities" :key="index + 'city'" @click="clickFunc(item)">{{ item.city_name }}</span>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import searchMixins from '@/mixins/search/config' 

export default {
  name:'TipsBlock',
  data () {
    return {
      nowIndex: 0,
      positionMap: ['热门城市', 'ABCDE', 'FGHJ', 'KLMN', 'PQRST', 'WXYZ']
    }
  },
  props: {
    show:{
      type: Boolean,
      default: false
    },
    activeCity:{
      type: String,
      default: '全国'
    }
  },
  mixins: [searchMixins],
  methods: {
    // 切换 tag
    toggleTag (data, index) {

      this.nowIndex = index

      let scrollY = null
      let cityContent = this.$refs['city-content']
      if (data === '热门城市') {
        scrollY = 0
      } else {
        scrollY= this.$refs[`tag-${data[0]}`][0].offsetTop
      }
      cityContent.scrollTop = scrollY
    },
    clickFunc (data) {
      this.$emit('clickFunc', data)
    },
    closeFunc () {
      this.$emit('closeFunc')
    }
  },
}
</script>

<style lang="scss" scoped>
  .bg{
    position: fixed;
    z-index: 9;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha:0.5);

    .content{
      width: 600px;
      box-sizing: border-box;
      box-shadow:0px 1px 3px 0px rgba(0,0,0,0.03);
      border-radius:4px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 24px 0;

      .city-header {
        display: flex;
        justify-content: space-between;
        padding: 0 24px;
        margin-bottom: 24px;

        .city-title {
          font-size: 16px;
          font-weight: 500;
          color: #404040;
          line-height: 16px;
        }

        .iconquxiao {
          cursor: pointer;
          font-size: 18px;
          color: #BCBCBC;
        }
      }

      .position-box {
        display: flex;
        justify-content: space-between;
        padding: 10px 24px;
        background: rgba(255, 102, 68, 0.04);
        margin-bottom: 22px;

        >span {
          position: relative;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          line-height: 14px;

          &:hover {
            color: #4183FF;
            
            &::after {
              content: "";
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 32px;
              height: 2px;
              background: #4183FF;
              border-radius: 1px;
            }

          }
          
          &.active {
            color: #4183FF;
            &::after {
              content: "";
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 32px;
              height: 2px;
              background: #4183FF;
              border-radius: 1px;
            }
          }

        }
      }

      .city-content {
        position: relative;
        height: 280px;
        padding-left: 24px;
        overflow: auto;
        /* 隐藏滚动条 */
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        /* 滚动有过渡动画 */
        scroll-behavior: smooth;

        .city-item {
          display: flex;

          .city-tag {
            font-size: 14px;
            font-weight: 400;
            color: #4183FF;
            line-height: 20px;
            margin-right: 30px;
          }

          .city-box {
            flex: 1;
            display: flex;
            flex-wrap: wrap;

            .city {
              cursor: pointer;
              width: 107px;
              font-size: 14px;
              font-weight: 400;
              color: #404040;
              line-height: 20px;
              margin-bottom: 24px;

              &:hover {
                color: #4183FF;
              }

              &.active {
                color: #4183FF;
              }
            }
          }
        }
      }

    }

  }
</style>